import React, { useState } from 'react';
import './App.css';
import Breadcrumbs from './components/Breadcrumbs';
import NavLinks from './components/NavLinks';
import WhatIsOsap from './components/WhatIsOsap';
import HowToApply from './components/HowToApply';
import CommonMistakes from './components/CommonMistakes';
import BenefitsOfHelp from './components/BenefitsOfHelp';
import UserDetailsForm from './components/UserDetailsForm';
import Modal from './components/Modal';
// import Accordion from './components/Accordion';
import Button from './components/Button';
import RelatedSidebar from './components/RelatedSidebar';
import Footer from './components/Footer';
import { Analytics } from "@vercel/analytics/react"

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="App">
      <Analytics />
      <Breadcrumbs />
      <main>
        <div className="main-content">
          <h1>
            How to apply for <span className="osap-highlight">OSAP</span>
          </h1>
          <p className="subtitle">
            Find out how to apply for <span className="osap-highlight">OSAP</span>.
          </p>
          <div className="button-container">
            <Button onClick={handleOpenModal} id="get-help">
              Get help
            </Button>
            <Button href="https://osap.gov.on.ca/OSAPSecurityWeb/public/login.xhtml?lang=en">Apply now</Button>
          </div>
          <NavLinks />
          <div className="content-with-sidebar">
            <div className="content-sections">
              <WhatIsOsap />
              <HowToApply onRequestAssistance={handleOpenModal} />
              <CommonMistakes onRequestAssistance={handleOpenModal} />
              <BenefitsOfHelp onRequestAssistance={handleOpenModal} />
              {/* <Accordion /> */}
            </div>
            <RelatedSidebar />
          </div>
        </div>
      </main>
      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <UserDetailsForm />
      </Modal>
      <Footer />
    </div>
  );
}

export default App;